export default __webpack_public_path__ + "static/media/carrot-logosymbol-bg.179f8cdf.svg";